import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import JsonExcel from 'vue-json-excel'
import moment from 'moment'

Vue.component('downloadExcel',JsonExcel)

Vue.config.productionTip = false

Vue.use(ElementUI)

Vue.prototype.$moment = moment

new Vue({
    router,
  render: h => h(App),
}).$mount('#app')
